import styled from 'styled-components';
import { Container, Title } from '../../styles';
import { MOBILE, TABLET } from '../../../../../utils/screen';

export const ContainerSemaphore = styled(Container)``;

export const TitleSemaphore = styled(Title)`
  @media (max-width: ${MOBILE}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.875rem;
    margin-bottom: 10px;

    span {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;

export const ContainerCard = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;

  @media (max-width: ${TABLET}px) {
    grid-template-columns: 1fr 1fr;
    gap: 0.678rem;
  }

  @media (max-width: ${MOBILE}px) {
    grid-template-columns: 1fr;
    display: none;

    animation: keyframeDisplay 0.5s ease-in-out;
  }
`;
